/**
 * @generated SignedSource<<93863e3077fd02ca9ba67c0a93d9a7d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useInitializeDiningBookingWizard_diningReservationHold$data = {
  readonly date: string | null | undefined;
  readonly expiresAt: string | null | undefined;
  readonly id: string;
  readonly partySize: number | null | undefined;
  readonly policy: string | null | undefined;
  readonly time: string | null | undefined;
  readonly " $fragmentType": "useInitializeDiningBookingWizard_diningReservationHold";
};
export type useInitializeDiningBookingWizard_diningReservationHold$key = {
  readonly " $data"?: useInitializeDiningBookingWizard_diningReservationHold$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeDiningBookingWizard_diningReservationHold">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeDiningBookingWizard_diningReservationHold",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partySize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "policy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    }
  ],
  "type": "DiningReservationHold",
  "abstractKey": null
};

(node as any).hash = "201ed57e8ba930b607c7fa3c7fd82cb8";

export default node;
